/**
 * IDs fixos dos dois módulos/bases de dados separadas.
 * SIADAP & Progressões usa sempre MUNICIPIO_SIADAP_ID.
 * Gestão da Formação usa sempre MUNICIPIO_FORMACAO_ID.
 * Estes valores são independentes do município selecionado pelo utilizador.
 */
export const MUNICIPIO_SIADAP_ID = '00000000-0000-0000-0000-000000000001';
export const MUNICIPIO_FORMACAO_ID = 'a0a26eb3-c7ad-46e3-a8be-9cdcb2316576';
